export default __webpack_public_path__ + "static/media/uk.f9dac62a.png";